import { ProductShare } from '../components/ProductShare';
import { useProductShareService } from '../services/useProductShareService';

export const ProductShareContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useProductShareService();
  return <ProductShare {...service} />;
};
